// extracted by mini-css-extract-plugin
export default {"selectedTag":"InputTags_selectedTag__tookn","tagContainer":"InputTags_tagContainer__C-5vh"};